import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Landing from './pages/Landing';
import MyPayments from './pages/MyPayments';
import Login from './pages/Login';
import Register from './pages/Register';
import ResetPassword from './pages/ResetPassword';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import AdminDashboard from './pages/AdminDashboard';
import UserDashboard from './pages/UserDashboard';
import MyDomains from './pages/MyDomains';
import Billing from './pages/Billing'; // ✅ NEW
import Settings from './pages/Settings';
import DomainDetails from './pages/DomainDetails';
import PaymentSuccess from './pages/PaymentSuccess'; // ✅ NEW
import PaymentFail from './pages/PaymentFail'; // ✅ NEW
import axios from 'axios';
import './App.css';
import i18n from './i18n';
import HowItWorks from "./pages/HowItWorks";

const API_URL = process.env.REACT_APP_API_URL || 'https://localhost:3001/api';
axios.defaults.baseURL = API_URL;
axios.defaults.withCredentials = true;

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    verifyToken();
  }, []);

  const verifyToken = async () => {
    try {
      const response = await axios.get('/auth/verify');
      if (response.data.success) {
        setUser(response.data.user);
        i18n.changeLanguage(response.data.user.language || 'en');
      }
    } catch (error) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    try {
      await axios.post('/auth/logout');
    } catch (err) {
      console.error('Logout error:', err);
    }
    setUser(null);
    window.location.href = '/login';
  };

  const handleUpdateUser = (updatedUser) => {
    setUser(updatedUser);
    i18n.changeLanguage(updatedUser.language || 'en');
  };

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Landing />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* Auth Routes */}
        <Route
          path="/login"
          element={user ? <Navigate to="/dashboard" replace /> : <Login />}
        />
        <Route
          path="/register"
          element={user ? <Navigate to="/dashboard" replace /> : <Register />}
        />

        {/* Dashboard */}
        <Route
          path="/dashboard"
          element={
            user ? (
              user.role === 'admin' ? (
                <AdminDashboard user={user} onLogout={handleLogout} />
              ) : (
                <UserDashboard user={user} onLogout={handleLogout} />
              )
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        {/* ✅ Billing - Fatura Bilgileri */}
        <Route
          path="/billing"
          element={
            user ? (
              <Billing user={user} onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        {/* Payments */}
        <Route
          path="/payments"
          element={
            user ? (
              <MyPayments user={user} onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        {/* ✅ Payment Success/Fail Pages */}
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/fail" element={<PaymentFail />} />

        {/* Settings */}
        <Route
          path="/settings"
          element={
            user ? (
              <Settings
                user={user}
                onLogout={handleLogout}
                onUpdateUser={handleUpdateUser}
              />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        {/* Domain Routes */}
        {user ? (
          <>
            {user.role === 'admin' ? (
              <>
                <Route path="/domains/:domainId" element={<DomainDetails user={user} onLogout={handleLogout} />} />
              </>
            ) : (
              <>
                <Route path="/domains" element={<MyDomains user={user} onLogout={handleLogout} />} />
                <Route path="/domains/:domainId" element={<DomainDetails user={user} onLogout={handleLogout} />} />
              </>
            )}
          </>
        ) : (
          <Route path="*" element={<Navigate to="/" replace />} />
        )}

        <Route
          path="/how-it-works"
          element={
            user ? (
              <HowItWorks user={user} onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
